import AboutHero from './components/AboutHero';
import CathyStory from './components/CathyStory';
import MissionVision from './components/MissionVision';
import CTASection from '@/pages/home/components/CTASection';
import SEO from '@/components/feature/SEO';

const AboutPage = () => {
  return (
    <main>
      <SEO 
        title="Sobre Nosotros | Sbdigisolutions" 
        description="Conoce la historia detrás de Sbdigisolutions, nuestra misión, visión y a nuestro equipo de expertos en marketing digital." 
      />
      <AboutHero />
      <CathyStory />
      <MissionVision />
      <CTASection />
    </main>
  );
};

export default AboutPage;
